/*
 * @Author: hzm
 * @Date: 2023-08-10 14:15:45
 * @Description:
 */
import http from '@/utils/request';

//  获取用户积余额
export function getPoints() {
  return http.request({
    url: `/mro/pointsInfo/getUserPoints`,
    method: 'get',
  });
}

export function getPointsReordList(pointsId) {
  return http.request({
    url: `/mro/pointsRecord/getUserPointsReordList/${pointsId.id}`,
    method: 'get',
    params: pointsId,
  });
}

// 兑换量排行
export function getPointsRankingList(query) {
  return http.request({
    url: `/mro/portalOrder/restful/getSaleQtyProductTops/` + query.zoneId,
    method: 'get',
    params: query,
  });
}

//  兑换金额排行
export function getPointsMoneyRankingList(query) {
  return http.request({
    url: `/mro/portalOrder/restful/getSaleAmountProductTops/` + query.zoneId,
    method: 'get',
    params: query,
  });
}

// 最近兑换
export function getZoneRecentProducts(query) {
  return http.request({
    url: `/mro/portalOrder/restful/getZoneRecentProducts/` + query.zoneId,
    method: 'get',
    params: query,
  });
}

// 积分兑换成功
export function exchangePoint(activiCode) {
  return http.request({
    url: `/mro/pointsCode/active/${activiCode}`,
    method: 'put',
  });
}

export function getUserVtcrMainInfo() {
  return http.request({
    url: `/mro/vtcrMain/getUserInfo`,
    method: 'get',
  });
}

// 充值积分 记录 mro/vtcrChangeRecord/getByMainId/{mainId}
export function getRechargeRecord(params) {
  return http.request({
    url: `/mro/vtcrChangeRecord/getByMainId/${params.id}`,
    method: 'get',
    params,
  });
}

// 用户充值积分订单 /mro/vtcrOrder/list

export function getVtcrOrderList(query) {
  return http.request({
    url: '/mro/vtcrOrder/getUserList',
    method: 'get',
    params: query,
  });
}

// 用户取消订单
export function cancelOrder(id) {
  return http.request({
    url: `/mro/vtcrOrder/closeOrder/${id}`,
    method: 'put',
  });
}

export function uploadPaymentVoucher(data) {
  return http.request({
    url: `/mro/vtcrOrder/uploadPayCertificate`,
    method: 'put',
    data,
  });
}

export function createUserOrder(data) {
  return http.request({
    url: `/mro/vtcrOrder/createUserOrder`,
    method: 'post',
    data,
  });
}
